import Cart from '../Cart'
import BuynowCart from '../BuyNowCart'
import React, { useState, useContext, useEffect } from 'react'
import AuthContext from '@/product/context/auth/authContext'
import EmptyCart from '../EmptyCart'
const SingleCart = () => {
    const authContext = useContext(AuthContext)
    const { cartCount } = authContext
    const [count, setCount] = useState({
        auctionCount: 0,
        buynowCount: 0,
    })
    const [total, setTotal] = useState(0)
    useEffect(() => {
        if (cartCount?.auctionCount) {
            setCount({ ...count, auctionCount: cartCount.auctionCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
    }, [cartCount])

    useEffect(() => {
        setTotal(count.buynowCount + count.auctionCount)
    }, [count])
    return (
        <>
            {total > 0 ? (
                <>
                    {' '}
                    {count.buynowCount > 0 ? <BuynowCart></BuynowCart> : null}
                    {count.auctionCount > 0 ? <Cart></Cart> : null}
                </>
            ) : (
                <div className="cart customContainer">
                    <div className="d-flex justify-content-between">
                        <EmptyCart />
                    </div>
                </div>
            )}
        </>
    )
}

export default SingleCart
